var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"menu-profile-item",attrs:{"to":{ name: _vm.name }}},[(_vm.hasIcon)?_c('img',{staticClass:"header-menuitem-icon list-icon",attrs:{"src":require("@/assets/svg/icon-list.svg")}}):_vm._e(),_vm._v(" "+_vm._s(_vm.$t('route.shoppingList'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }